import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import OfferDescriptionLoadingSkeleton from 'components/Common/Loading/OfferDescriptionLoadingSkeleton'
import AISparkleIcon from 'components/Search/SearchForm/AISparkleIcon'

const DescriptionContainer = styled.div`
  padding: ${rem(8)} ${rem(12)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
`

const InlineSparkleIcon = styled.span`
  display: inline-flex;
  vertical-align: text-bottom;
  margin-inline-end: ${rem(4)};
`

const SPARKLE_ICON = (
  <InlineSparkleIcon>
    <AISparkleIcon size="S" />
  </InlineSparkleIcon>
)

interface Props {
  description?: Array<string>
  isLoading?: boolean
  className?: string
}

function OfferDescription({ description, isLoading = false, className }: Props) {
  if (isLoading) {
    return <OfferDescriptionLoadingSkeleton className={className} />
  }

  if (!description || description.length === 0) {
    return null
  }

  return (
    <DescriptionContainer className={className}>
      <BodyText
        variant="medium"
        colour="light-foreground-alt"
      >
        {SPARKLE_ICON}
        {description[0]}
      </BodyText>
    </DescriptionContainer>
  )
}

export default OfferDescription
